import {
  CUSTOMER_DESER,
  Customer,
  ORDER_DESER,
  Order,
  PER_PAGE,
  type ItemsResponse,
  type SingleResponse,
} from "../../tastyworks"
import {
  REQUIRED_DOCUMENT_DESER,
  RequiredDocument,
  SUPPORTING_DOCUMENT_DESER,
  SupportingDocument,
  customerIdParam,
} from "../../tastyworks/customer"
import type HttpClient from "../../tastyworks/http"

const CUSTOMER_PARTIAL_VERSION = "20260910"

type CustomerVersion = typeof CUSTOMER_PARTIAL_VERSION

export class CustomerService {
  constructor(
    private readonly baseHttpClient: HttpClient,
    private readonly customerMeClient: HttpClient
  ) {}

  readonly create = async (
    customer: Customer,
    options: {
      version?: CustomerVersion
    } = {}
  ): Promise<SingleResponse<Customer>> => {
    const headers = options.version
      ? { "Accept-Version": options.version }
      : undefined

    return this.baseHttpClient.create(
      customer,
      CUSTOMER_DESER.serialize,
      CUSTOMER_DESER.update,
      "customers",
      undefined,
      headers
    )
  }

  readonly show = async (
    customerId?: number
  ): Promise<SingleResponse<Customer>> =>
    this.customerMeClient.show(new Customer(), CUSTOMER_DESER.update, "", {
      customerId,
    })

  readonly update = async (
    customer: Customer,
    options: {
      version?: CustomerVersion
    } = {}
  ): Promise<SingleResponse<Customer>> => {
    const headers = options.version
      ? { "Accept-Version": options.version }
      : undefined

    return this.customerMeClient.update(
      customer,
      CUSTOMER_DESER.serialize,
      CUSTOMER_DESER.update,
      undefined,
      undefined,
      headers
    )
  }

  readonly getRequiredIdentityDocuments = async (): Promise<
    ItemsResponse<RequiredDocument>
  > =>
    this.customerMeClient.indexSimple(
      REQUIRED_DOCUMENT_DESER.toParser(RequiredDocument),
      "/required-identity-documents",
      customerIdParam(this.customerMeClient.session)
    )

  readonly getSupportingDocuments = async (): Promise<
    ItemsResponse<SupportingDocument>
  > =>
    this.customerMeClient.indexSimple(
      SUPPORTING_DOCUMENT_DESER.toParser(SupportingDocument),
      "/supporting-documents",
      customerIdParam(this.customerMeClient.session)
    )

  /**
   * gets orders across all accounts
   * @returns
   */
  readonly getFilledOrders = async (
    accountNumbers: string[],
    perPage = PER_PAGE
  ): Promise<ItemsResponse<Order>> => {
    const params = {
      "account-numbers": accountNumbers,
      status: "Filled",
      "per-page": perPage,
    }
    return this.customerMeClient.indexSimple(
      ORDER_DESER.toParser(Order),
      "/orders",
      params
    )
  }
}
